export default theme => ({
    sectionTitleContainer: {
        display: 'flex',
        paddingBottom: 15,
        justifyContent: 'center',
        borderBottom:'solid 1px #ddd',
        '& .sectionTitle': {
            textAlign: 'center',
            fontWeight: 'bold',
            textTransform: 'uppercase',
            width: '100%',
            color: '#212121',
            fontSize: '1em',
            margin: 0,
            [theme.breakpoints.up('md')]: {
                display: 'inline-block',
                width: 'initial',
            }
        },
        '& .sectionRight': {
            textTransform: 'uppercase',
        },
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'space-between',
        }
    },
});
